import { makeStyles } from '@surveycake/rc';

const progressWidthPercentage = 95;

export const useStyles = makeStyles([
  [
    'progressContainer',
    `
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
	`
  ],
  [
    'progress',
    theme => `
		position: relative;
		flex: 1 1 ${progressWidthPercentage}%;
		height: 8px;
		border-radius: 4px;
		background-color: ${theme.color.primary.background};
		overflow: hidden;
	`
  ],
  [
    'track',
    theme => `
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 100%;
		border-radius: 4px;
		background-color: ${theme.color.primary.default};
		transition: transform 0.2s linear;
		transform-origin: left;
	`
  ],
  [
    'percentage',
	`
		:lang(ar){
			transform: scaleX(-1);
		}
		flex: 1 1 ${100 - progressWidthPercentage}%;
		margin-left: 10px;
	`
  ]
]);
